'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Dialog } from '@/shared/components/ui';
import { FeatherArrowLeft, FeatherArrowRight, FeatherCheck, FeatherFileText, FeatherMail, FeatherMessageCircle, FeatherMoreVertical, FeatherSend, FeatherShield, FeatherSparkles } from '@subframe/core';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import type { ProdutoKey, ProdutoModalProps } from '../types/produtoModalTypes';
interface ProdutoSlide {
  titulo: string;
  descricao: string;
}
interface ProdutoModalConfig {
  ctaLabel: string;
  slides: ProdutoSlide[];
}
const MODAL_CONFIG: Record<ProdutoKey, ProdutoModalConfig> = {
  regua: {
    ctaLabel: 'Ativar régua',
    slides: [{
      titulo: 'Régua de cobrança automática',
      descricao: 'Configure uma sequência de lembretes e cobranças que dispara sozinha, no tempo certo, para cada devedor.'
    }, {
      titulo: 'Cada etapa no momento certo',
      descricao: 'Do lembrete amigável no D+0 à notificação formal no D+15 — você define os passos e a régua cuida do envio.'
    }, {
      titulo: 'Menos trabalho manual, mais acordos',
      descricao: 'Acompanhe o progresso de cada cobrança em um só lugar e deixe a régua trabalhar por você.'
    }]
  },
  agentes: {
    ctaLabel: 'Conhecer a Lexi',
    slides: [{
      titulo: 'Agentes de IA para negociar',
      descricao: 'A Lexi é a sua negociadora de inteligência artificial: ela assume as conversas e cobra por você, com jeito e firmeza.'
    }, {
      titulo: 'Presente em todos os canais',
      descricao: 'WhatsApp, Telegram, e-mail e mais — a Lexi conversa com o devedor onde ele estiver, 24 horas por dia.'
    }, {
      titulo: 'Você sempre no controle',
      descricao: 'Acompanhe cada diálogo de perto e assuma a conversa quando quiser. A Lexi cuida do resto para você.'
    }]
  },
  notificacao: {
    ctaLabel: 'Criar notificação',
    slides: [{
      titulo: 'Notificação extrajudicial',
      descricao: 'Envie avisos formais a devedores com validade e rastreabilidade, sem sair da plataforma.'
    }, {
      titulo: 'Modelos prontos e personalizáveis',
      descricao: 'Use modelos jurídicos revisados ou crie os seus. É só preencher os dados e enviar.'
    }, {
      titulo: 'Envio e comprovação em um clique',
      descricao: 'Acompanhe o status de cada notificação — enviada, recebida, lida — com comprovante para o processo.'
    }]
  }
};
function ReguaEtapa(t0) {
  const $ = _c(18);
  const {
    nome,
    prazo,
    nodeClass,
    chkClass,
    barClass,
    barColor
  } = t0;
  const t1 = `border-brand-200 relative flex h-6 w-6 flex-none items-center justify-center rounded-full border-2 bg-white ${nodeClass}`;
  const t2 = `h-3 w-3 text-white ${chkClass}`;
  let t3;
  if ($[0] !== t2) {
    t3 = <FeatherCheck className={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t1 || $[3] !== t3) {
    t4 = <span className={t1}>{t3}</span>;
    $[2] = t1;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== nome) {
    t5 = <span className="text-[11px] font-medium text-neutral-700">{nome}</span>;
    $[5] = nome;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `h-full w-full rounded-full ${barColor} ${barClass}`;
  let t7;
  if ($[7] !== t6) {
    t7 = <div className="bg-brand-100 h-[7px] w-full overflow-hidden rounded-full"><div className={t6} /></div>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t5 || $[10] !== t7) {
    t8 = <div className="flex flex-1 flex-col gap-1.5">{t5}{t7}</div>;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== prazo) {
    t9 = <span className="text-brand-600 w-8 text-right text-[11px] font-semibold">{prazo}</span>;
    $[12] = prazo;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t4 || $[15] !== t8 || $[16] !== t9) {
    t10 = <div className="flex items-center gap-3">{t4}{t8}{t9}</div>;
    $[14] = t4;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}
export function ReguaPanel() {
  const $ = _c(9);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-[18px] flex items-center justify-between"><span className="text-brand-600 text-[13px] font-semibold">Régua de cobrança</span><span className="bg-brand-400 rounded-full px-2.5 py-[3px] text-[10px] font-semibold text-white">3 devedores</span></div>;
    t1 = <ReguaEtapa nome={"Lembrete amig\xE1vel"} prazo="D+0" nodeClass="pm-r-node1" chkClass="pm-r-chk1" barClass="pm-r-bar1" barColor="bg-brand-600" />;
    t2 = <div className="bg-brand-200 pm-r-ln1 ml-[11px] h-4 w-0.5" />;
    t3 = <ReguaEtapa nome={"Cobran\xE7a formal"} prazo="D+7" nodeClass="pm-r-node2" chkClass="pm-r-chk2" barClass="pm-r-bar2" barColor="bg-brand-600" />;
    t4 = <div className="bg-brand-200 pm-r-ln2 ml-[11px] h-4 w-0.5" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="border-brand-400 pm-r-send relative flex h-6 w-6 flex-none items-center justify-center rounded-full border-2 bg-white"><span className="bg-brand-400 h-2 w-2 rounded-full" /></span>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-[11px] font-medium text-neutral-700">Notificação extrajudicial</span>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex items-center gap-3">{t5}<div className="flex flex-1 flex-col gap-1.5">{t6}<div className="bg-brand-100 h-[7px] w-full overflow-hidden rounded-full"><div className="bg-brand-300 pm-r-bar3 h-full w-full rounded-full" /></div></div><span className="text-brand-400 w-8 text-right text-[11px] font-semibold">D+15</span></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="pm-float relative z-10 flex w-[80%] flex-col rounded-[14px] bg-white px-6 pt-[22px] pb-7 shadow-2xl">{t0}{t1}{t2}{t3}{t4}{t7}<div className="bg-brand-600 pm-r-toast absolute -bottom-3.5 left-1/2 flex items-center gap-1.5 rounded-full px-3.5 py-1.5 whitespace-nowrap shadow-lg"><FeatherCheck className="h-3 w-3 text-white" /><span className="text-[11px] font-semibold text-white">Cobrança enviada</span></div></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}
function DoubleTick() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="wa-tick h-[9px] w-[15px]" viewBox="0 0 30 18" fill="none" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round"><polyline points="3 9 8 14 17 4" /><polyline points="12 14 21 4" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function AgentesPanel() {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="pm-agentes-bg" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherArrowLeft className="h-[18px] w-[18px] flex-none text-white" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="from-brand-300 to-brand-400 flex h-[34px] w-[34px] flex-none items-center justify-center rounded-full bg-gradient-to-br"><FeatherSparkles className="h-[17px] w-[17px] text-white" /></span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-[13px] font-semibold text-white">Lexi · Arbitralis</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="wa-header flex items-center gap-2.5 px-3.5 py-2.5">{t1}{t2}<div className="flex min-w-0 flex-1 flex-col">{t3}<span className="relative block h-[13px]"><span className="pm-wa-online absolute top-0 left-0 text-[11px] text-white/75">online</span><span className="pm-wa-typing absolute top-0 left-0 text-[11px] text-white/85 italic">digitando…</span></span></div><FeatherMoreVertical className="h-[17px] w-[17px] flex-none text-white/85" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="wa-bubble-in pm-wa-b1 max-w-[78%] self-start rounded-[10px] rounded-tl-[2px] px-2.5 pt-[7px] pb-[5px] shadow-sm"><span className="block text-xs leading-snug text-neutral-800">Vi a cobrança, mas não consigo pagar tudo agora.</span><span className="mt-0.5 block text-right text-[9px] text-neutral-400">09:41</span></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="block text-xs leading-snug text-neutral-800">Sem problema! Consigo dividir em até 3x sem juros. Ajuda?</span>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="wa-bubble-out pm-wa-b2 max-w-[80%] self-end rounded-[10px] rounded-tr-[2px] px-2.5 pt-[7px] pb-[5px] shadow-sm">{t6}<span className="mt-0.5 flex items-center justify-end gap-1"><span className="text-[9px] text-neutral-500">09:41</span><DoubleTick /></span></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="wa-bubble-in pm-wa-b3 max-w-[78%] self-start rounded-[10px] rounded-tl-[2px] px-2.5 pt-[7px] pb-[5px] shadow-sm"><span className="block text-xs leading-snug text-neutral-800">Ajudaria muito! Pode ser.</span><span className="mt-0.5 block text-right text-[9px] text-neutral-400">09:42</span></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="block text-xs leading-snug text-neutral-800">Fechado! Já te enviei o link da 1ª parcela.</span>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="wa-bubble-out pm-wa-b4 max-w-[80%] self-end rounded-[10px] rounded-tr-[2px] px-2.5 pt-[7px] pb-[5px] shadow-sm">{t9}<span className="mt-0.5 flex items-center justify-end gap-1"><span className="text-[9px] text-neutral-500">09:42</span><DoubleTick /></span></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="wa-body relative flex flex-1 flex-col gap-2 p-3.5">{t5}{t7}{t8}{t10}<div className="wa-agreement pm-wa-b5 mt-0.5 flex items-center gap-1.5 self-center rounded-full px-3 py-1.5"><FeatherCheck className="h-3 w-3" /><span className="text-[11px] font-semibold">Acordo fechado</span></div></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex h-[30px] flex-1 items-center rounded-full bg-white px-3 text-[11px] text-neutral-400">Mensagem</div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <>{t0}<div className="wa-panel pm-float relative z-10 flex h-[440px] w-[70%] flex-col overflow-hidden rounded-[22px] shadow-2xl">{t4}{t11}<div className="wa-input-bar flex items-center gap-2 px-3 py-2">{t12}<span className="wa-send flex h-8 w-8 flex-none items-center justify-center rounded-full"><FeatherSend className="h-[15px] w-[15px] text-white" /></span></div></div></>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  return t13;
}
function CanalCertificado(t0) {
  const $ = _c(14);
  const {
    icon,
    label,
    onClass,
    chkClass
  } = t0;
  const t1 = `absolute inset-0 flex items-center justify-center rounded-[12px] ${onClass}`;
  let t2;
  if ($[0] !== icon || $[1] !== t1) {
    t2 = <span className={t1}>{icon}</span>;
    $[0] = icon;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `bg-success-600 absolute -top-1 -right-1 flex h-[17px] w-[17px] items-center justify-center rounded-full border-2 border-white ${chkClass}`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FeatherCheck className="h-2 w-2 text-white" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <span className={t3}>{t4}</span>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t5) {
    t6 = <span className="relative flex h-11 w-11 items-center justify-center rounded-[12px]">{t2}{t5}</span>;
    $[6] = t2;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== label) {
    t7 = <span className="text-[10px] font-medium text-neutral-600">{label}</span>;
    $[9] = label;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <div className="flex flex-1 flex-col items-center gap-[7px]">{t6}{t7}</div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}
function NotificacaoPanel() {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="pm-notif-bg" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="bg-coral-500 flex h-[30px] w-[30px] flex-none items-center justify-center rounded-[7px]"><FeatherFileText className="h-4 w-4 text-white" /></span>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-2.5">{t1}<div className="flex flex-1 flex-col gap-1"><span className="text-[12px] font-semibold text-neutral-800">Notificação extrajudicial</span><div className="h-1 w-[70%] rounded-full bg-neutral-200" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-1.5"><div className="h-1 w-full rounded-full bg-neutral-200" /><div className="h-1 w-[92%] rounded-full bg-neutral-200" /><div className="h-1 w-[97%] rounded-full bg-neutral-200" /></div>;
    t4 = <span className="mt-0.5 text-[10px] font-semibold tracking-[0.03em] text-neutral-400 uppercase">Enviada por</span>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CanalCertificado icon={<FeatherFileText className="h-5 w-5" />} label="Carta" onClass="pm-ne-on1" chkClass="pm-ne-chk1" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CanalCertificado icon={<FeatherMail className="h-5 w-5" />} label="E-mail" onClass="pm-ne-on2" chkClass="pm-ne-chk2" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex items-start justify-between gap-2.5">{t5}{t6}<CanalCertificado icon={<FeatherMessageCircle className="h-5 w-5" />} label="WhatsApp" onClass="pm-ne-on3" chkClass="pm-ne-chk3" /></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <>{t0}<div className="pm-float relative z-10 flex w-[70%] flex-col gap-3.5 rounded-[14px] bg-white px-[22px] pt-5 pb-[30px] shadow-2xl">{t2}{t3}{t4}{t7}<div className="pm-ne-cert absolute -bottom-[15px] left-1/2 flex items-center gap-1.5 rounded-full bg-neutral-800 px-3.5 py-[7px] whitespace-nowrap shadow-lg"><FeatherShield className="text-success-300 h-3.5 w-3.5" /><span className="text-[11px] font-semibold text-white">Certificado de acesso</span></div></div></>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}
const PANEL_BY_KEY: Record<ProdutoKey, React.ReactNode> = {
  regua: <ReguaPanel />,
  agentes: <AgentesPanel />,
  notificacao: <NotificacaoPanel />
};
export function ProdutoModal(t0) {
  const $ = _c(51);
  const {
    produtoKey,
    onClose,
    onAction
  } = t0;
  const [slide, setSlide] = useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setSlide(0);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== produtoKey) {
    t2 = [produtoKey];
    $[1] = produtoKey;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!produtoKey) {
    return null;
  }
  const config = MODAL_CONFIG[produtoKey];
  const slides = config.slides;
  const atual = slides[slide];
  const isFirst = slide === 0;
  const isLast = slide === slides.length - 1;
  let t3;
  if ($[3] !== isLast || $[4] !== onAction || $[5] !== onClose) {
    t3 = () => {
      if (isLast) {
        onClose();
        onAction?.();
        return;
      }
      setSlide(_temp);
    };
    $[3] = isLast;
    $[4] = onAction;
    $[5] = onClose;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleAvancar = t3;
  const t4 = atual.titulo;
  let t5;
  if ($[7] !== onClose) {
    t5 = open => !open && onClose();
    $[7] = onClose;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Image src="/icone.svg" alt="Arbitralis" width={32} height={32} className="h-8 w-8" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== atual.titulo) {
    t7 = <h2 className="text-[26px] leading-tight font-semibold text-neutral-800">{atual.titulo}</h2>;
    $[10] = atual.titulo;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== atual.descricao) {
    t8 = <p className="text-base leading-relaxed text-neutral-500">{atual.descricao}</p>;
    $[12] = atual.descricao;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <div className="flex flex-col gap-8">{t6}<div className="flex flex-col gap-3">{t7}{t8}</div></div>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== slide || $[18] !== slides) {
    let t11;
    if ($[20] !== slide) {
      t11 = (_, index) => <button key={index} type="button" aria-label={`Ir para o slide ${index + 1}`} onClick={() => setSlide(index)} className={`h-2 rounded-full transition-all ${index === slide ? "bg-brand-600 w-6" : "w-2 bg-neutral-300"}`} />;
      $[20] = slide;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    t10 = slides.map(t11);
    $[17] = slide;
    $[18] = slides;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = <div className="flex items-center gap-2">{t10}</div>;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== isFirst || $[25] !== onClose) {
    t12 = isFirst ? <Button variant="neutral-secondary" onClick={onClose}>Agora não</Button> : <Button variant="neutral-secondary" icon={<FeatherArrowLeft />} onClick={() => setSlide(_temp2)}>Voltar</Button>;
    $[24] = isFirst;
    $[25] = onClose;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FeatherArrowRight />;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const t14 = isLast ? config.ctaLabel : "Continuar";
  let t15;
  if ($[28] !== handleAvancar || $[29] !== t14) {
    t15 = <Button variant="brand-primary" iconRight={t13} onClick={handleAvancar}>{t14}</Button>;
    $[28] = handleAvancar;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t12 || $[32] !== t15) {
    t16 = <div className="flex items-center gap-3">{t12}{t15}</div>;
    $[31] = t12;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t11 || $[35] !== t16) {
    t17 = <div className="flex flex-col gap-6">{t11}{t16}</div>;
    $[34] = t11;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t17 || $[38] !== t9) {
    t18 = <div className="flex flex-col justify-between gap-8 p-8 md:flex-[2]">{t9}{t17}</div>;
    $[37] = t17;
    $[38] = t9;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  let t20;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="pm-dots" />;
    t20 = <div className="pm-blur-orb" />;
    $[40] = t19;
    $[41] = t20;
  } else {
    t19 = $[40];
    t20 = $[41];
  }
  const t21 = PANEL_BY_KEY[produtoKey];
  let t22;
  if ($[42] !== t21) {
    t22 = <div className="from-brand-600 to-brand-800 relative flex min-h-[420px] items-center justify-center overflow-hidden bg-gradient-to-br md:flex-[3]">{t19}{t20}{t21}</div>;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t18 || $[45] !== t22) {
    t23 = <Dialog.Content className="w-full max-w-[980px] overflow-x-hidden overflow-y-auto rounded-[16px] border-0 p-0"><div className="flex w-full flex-col md:min-h-[600px] md:flex-row">{t18}{t22}</div></Dialog.Content>;
    $[44] = t18;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== atual.titulo || $[48] !== t23 || $[49] !== t5) {
    t24 = <Dialog open={true} title={t4} onOpenChange={t5}>{t23}</Dialog>;
    $[47] = atual.titulo;
    $[48] = t23;
    $[49] = t5;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  return t24;
}
function _temp2(prev_0) {
  return Math.max(0, prev_0 - 1);
}
function _temp(prev) {
  return prev + 1;
}